module.exports = __webpack_public_path__ + "static/img/qudi (5).8f10235.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qudi/qudi (5).jpg
// module id = 9FkV
// module chunks = 0